// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "meta_campaign_config".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { conversionDestinationAllValues, followUpTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "meta_campaign_config" table (1:1 with a DB row, on the wire). */
export const metaCampaignConfigAtomSchema = z.object({
    id: z.string(),
    metaCampaignId: z.string(),
    organizationId: z.string(),
    metaAdsPageId: z.string().nullable(),
    adAccountId: z.string().nullable(),
    adAccountCurrency: z.string().nullable(),
    followUpType: z.enum(followUpTypeValues),
    conversionDestination: z.enum(conversionDestinationAllValues).nullable(),
    destinationType: z.string().nullable(),
    leadFormId: z.string().nullable(),
    locationId: z.string().nullable(),
    targeting: z.unknown().nullable(),
    metaAdSetId: z.string().nullable(),
    experimentId: z.string().nullable(),
    experimentVariant: z.string().nullable(),
    createdInBorradh: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=metaCampaignConfig.js.map